import { render, staticRenderFns } from "./PackingFormContainer.vue?vue&type=template&id=3e70e11a&"
import script from "./PackingFormContainer.vue?vue&type=script&lang=js&"
export * from "./PackingFormContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports